let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l49JS")).then(() => parcelRequire('djm2H'));